module.exports = __webpack_public_path__ + "static/media/1.3.bc4b08f7.zip";